var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActBubbleWrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCF1CE;}\n\t.st1{fill:#9DD4E7;}\n\t.st2{fill:#C3E5F0;}\n\t.st3{fill:#FEFCF9;}\n\t.st4{fill:#FFE999;}\n\t.st5{fill:#F7A797;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,255c0,72.3,34.1,136.5,87,177.7V77.3C64.1,118.5,30,182.7,30,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480,255c0-72.3-34.1-136.5-87-177.7v355.4C445.9,391.5,480,327.3,480,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255,30c-52,0-99.9,17.7-138,47.3v355.4c38.1,29.6,86,47.3,138,47.3s99.9-17.7,138-47.3V77.3 C354.9,47.7,307,30,255,30z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000149352479238799535530000014374712279607122622_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.7,
    cy: 102.2,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 159.6,
    cy: 111.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.7,100.4c-0.2-6,3.9-10.9,10.1-11c5.4-0.2,5.4-8.6,0-8.4c-10.6,0.3-18.8,8.8-18.5,19.5 C127.5,105.8,135.9,105.9,135.7,100.4L135.7,100.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000127757298749965993840000005666682338192717455_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.7,
    cy: 162.8,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 139.5,
    cy: 173.7,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.5,149.8c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C145.1,141.5,145.1,150,150.5,149.8L150.5,149.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000104677661308857498120000011888999773870805427_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.7,
    cy: 223.3,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 139.5,
    cy: 234.2,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.5,210.3c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C145.1,202.1,145.1,210.5,150.5,210.3L150.5,210.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000071523127456598544680000018026363056543438209_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.7,
    cy: 283.9,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 139.5,
    cy: 294.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.5,270.9c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C145.1,262.6,145.1,271.1,150.5,270.9L150.5,270.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000004506671426196658040000012607133431082235269_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.7,
    cy: 344.4,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 139.5,
    cy: 355.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.5,331.4c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C145.1,323.2,145.1,331.6,150.5,331.4L150.5,331.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000077289810245906648390000007308910099232631185_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.7,
    cy: 405,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 157.9,
    cy: 394.1,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.9,418c-6,0.2-10.9-3.9-11-10.1c-0.2-5.4-8.6-5.4-8.4,0c0.3,10.6,8.8,18.8,19.5,18.5 C152.3,426.2,152.3,417.8,146.9,418L146.9,418z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000139980977143514512360000003700349321021698489_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 132.5,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 190.9,
    cy: 143.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.9,119.5c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C196.5,111.3,196.5,119.7,201.9,119.5L201.9,119.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000050657349789475266340000002576305318019332751_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 75.9,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 190.9,
    cy: 86.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.9,62.9c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C196.5,54.7,196.5,63.1,201.9,62.9L201.9,62.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000056396758456968744010000001107804818765464740_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 193.1,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 189.2,
    cy: 183.9,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.1,194.8c0.2,6-3.9,10.9-10.1,11c-5.4,0.2-5.4,8.6,0,8.4c10.6-0.3,18.8-8.8,18.5-19.5 C221.3,189.4,212.9,189.4,213.1,194.8L213.1,194.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000091015368281445353390000010867893434787081633_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 253.6,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 190.9,
    cy: 264.5,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.9,240.6c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C196.5,232.4,196.5,240.8,201.9,240.6L201.9,240.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000012465007367131463110000016415592097085703325_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 314.2,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 211,
    cy: 323.3,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.1,312.4c-0.2-6,3.9-10.9,10.1-11c5.4-0.2,5.4-8.6,0-8.4c-10.6,0.3-18.8,8.8-18.5,19.5 C178.9,317.8,187.3,317.8,187.1,312.4L187.1,312.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000103247100325334482840000012616667623634437523_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 374.7,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 190.9,
    cy: 385.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.9,361.7c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C196.5,353.5,196.5,361.9,201.9,361.7L201.9,361.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000106115861133630300380000002005141694768385951_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 435.3,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 190.9,
    cy: 446.2,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.9,422.3c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C196.5,414,196.5,422.5,201.9,422.3L201.9,422.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000176745445158725828860000005057378068544912258_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 252.5,
    cy: 102.2,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 241.6,
    cy: 93.1,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.5,104c0.2,6-3.9,10.9-10.1,11c-5.4,0.2-5.4,8.6,0,8.4c10.6-0.3,18.8-8.8,18.5-19.5 C273.8,98.6,265.3,98.6,265.5,104L265.5,104z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000144307362615347699100000003132359880688858508_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 252.5,
    cy: 162.8,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243.4,
    cy: 173.7,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.3,149.8c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C248.9,141.5,248.9,150,254.3,149.8L254.3,149.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000160895980933424151100000016735247504836990337_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 252.5,
    cy: 223.3,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243.4,
    cy: 234.2,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.3,210.3c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C248.9,202.1,248.9,210.5,254.3,210.3L254.3,210.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000174570667209825284980000012120349825332852617_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 252.5,
    cy: 283.9,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243.4,
    cy: 294.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.3,270.9c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C248.9,262.6,248.9,271.1,254.3,270.9L254.3,270.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000114793476477184060790000009932990690181253053_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 252.5,
    cy: 344.4,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 243.4,
    cy: 355.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.3,331.4c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C248.9,323.2,248.9,331.6,254.3,331.4L254.3,331.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000083782603184419858510000013273652190842496656_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 252.5,
    cy: 405,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 263.4,
    cy: 414.2,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.5,403.2c-0.2-6,3.9-10.9,10.1-11c5.4-0.2,5.4-8.6,0-8.4c-10.6,0.3-18.8,8.8-18.5,19.5 C231.3,408.6,239.7,408.6,239.5,403.2L239.5,403.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000119839958776597840920000017132535348451869614_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 359.6,
    cy: 102.2,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 350.5,
    cy: 113.1,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.4,89.2c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C356,81,356,89.4,361.4,89.2L361.4,89.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000006670838020633453810000016377917575449056642_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 359.6,
    cy: 162.8,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 370.5,
    cy: 171.9,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346.6,161c-0.2-6,3.9-10.9,10.1-11c5.4-0.2,5.4-8.6,0-8.4c-10.6,0.3-18.8,8.8-18.5,19.5 C338.4,166.4,346.8,166.4,346.6,161L346.6,161z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000057114116630527446300000007488558886070368426_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 359.6,
    cy: 223.3,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 350.5,
    cy: 234.2,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.4,210.3c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C356,202.1,356,210.5,361.4,210.3L361.4,210.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000134941810015408223000000004217939107209804198_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 359.6,
    cy: 283.9,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 350.5,
    cy: 294.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.4,268.4c3.6-0.2,7,0.9,9.5,3.4c2.5,2.4,3.9,5.7,4,9.1c0,2.3,3.5,2.3,3.5,0c0-4.4-1.8-8.6-5-11.6 c-3.2-3-7.6-4.6-12-4.4c-0.9,0.1-1.8,0.8-1.8,1.8C359.7,267.6,360.5,268.5,361.4,268.4L361.4,268.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000062149679420397715350000012935671490338891959_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 359.6,
    cy: 344.4,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 350.5,
    cy: 355.4,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.4,331.4c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C356,323.2,356,331.6,361.4,331.4L361.4,331.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000005255143029395188610000009207921870919600543_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 359.6,
    cy: 405,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 368.8,
    cy: 394.1,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.8,418c-6,0.2-10.9-3.9-11-10.1c-0.2-5.4-8.6-5.4-8.4,0c0.3,10.6,8.8,18.8,19.5,18.5 C363.2,426.2,363.3,417.8,357.8,418L357.8,418z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000121993942987537975280000013493200709308676523_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 132.5,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 293,
    cy: 123.3,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.9,134.3c0.2,6-3.9,10.9-10.1,11c-5.4,0.2-5.4,8.6,0,8.4c10.6-0.3,18.8-8.8,18.5-19.5 C325.2,128.9,316.7,128.9,316.9,134.3L316.9,134.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000163030721988885579340000005947365571380670891_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 75.9,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 294.8,
    cy: 86.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,62.9c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C300.3,54.7,300.3,63.1,305.7,62.9L305.7,62.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000133498049900962274160000000402375085138658951_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 193.1,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 294.8,
    cy: 204,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,180.1c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C300.3,171.8,300.3,180.2,305.7,180.1L305.7,180.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000142857891733478198060000016189117324230170780_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 253.6,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 294.8,
    cy: 264.5,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,240.6c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C300.3,232.4,300.3,240.8,305.7,240.6L305.7,240.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000137821139068574940160000016852628567115356070_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 314.2,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 314.8,
    cy: 323.3,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.9,312.4c-0.2-6,3.9-10.9,10.1-11c5.4-0.2,5.4-8.6,0-8.4c-10.6,0.3-18.8,8.8-18.5,19.5 C282.7,317.8,291.1,317.8,290.9,312.4L290.9,312.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000127004956629282622660000015578910562845538476_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 374.7,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 294.8,
    cy: 385.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,361.7c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C300.3,353.5,300.3,361.9,305.7,361.7L305.7,361.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_00000148650619593724838530000005210607108206638779_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 303.9,
    cy: 435.3,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 294.8,
    cy: 446.2,
    r: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,422.3c6-0.2,10.9,3.9,11,10.1c0.2,5.4,8.6,5.4,8.4,0c-0.3-10.6-8.8-18.8-19.5-18.5 C300.3,414,300.3,422.5,305.7,422.3L305.7,422.3z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.6,295.3c46-8.5,49.4-27.7,50.3-49c0.1-2.5-0.2-4.6-0.7-6.5c1.9,8.4-29.7,10.2-30.3,8.6 c0,0-1.7-8.1-18.7-15.6h0l0,0c-7.1-0.5-16.3-2.7-28.7-8.3c-20.2-9.2-38.7,1.9-47.5,8.8c-3.2,2.5-5.9,5.7-7.8,9.3L30.1,261 c1.2,47.1,17,90.6,42.9,126.3c1.1-4,2.5-7.8,4.1-11C86,358,87.7,301.9,123.6,295.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.9,248.4c0.6,1.5,32.2-0.2,30.3-8.6c0,0,0,0,0,0c-0.5-2-1.4-3.7-2.6-5.2c-2.7-3.1-6.9-4.9-11.7-6.1 c0,0,0,0,0,0c-1.5-0.4-2.9-0.4-4.7-0.3c-1.1,0.1-2.3,0.2-3.7,0.5c-5.1,0.8-12.6,2.5-26.2,4.2h0 C141.2,240.3,142.9,248.4,142.9,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M461.5,242.7c-2-3.6-4.6-6.7-7.8-9.3c-8.8-6.9-27.2-18-47.5-8.8c-12.4,5.6-21.6,7.7-28.7,8.3l0,0h0 c-17.1,7.4-18.7,15.6-18.7,15.6c-0.6,1.5-32.2-0.2-30.3-8.6c-0.5,1.9-0.8,4-0.7,6.5c0.9,21.3,4.3,40.5,50.3,49 c35.9,6.6,37.6,62.7,46.4,81c2.7,5.5,4.8,12.6,6,19.4c27-33.7,44.6-75.4,48.5-120.9L461.5,242.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M347.6,228.2c-1.7-0.1-3.2-0.1-4.7,0.3c0,0,0,0,0,0c-4.8,1.2-9.1,3-11.7,6.1c-1.2,1.4-2.2,3.1-2.6,5.2 c0,0,0,0,0,0c-1.9,8.4,29.7,10.2,30.3,8.6c0,0,1.7-8.1,18.7-15.6h0c-13.6-1.7-21.1-3.3-26.2-4.2 C350,228.4,348.7,228.3,347.6,228.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActBubbleWrap);
export default __webpack_public_path__ + "static/media/ActBubbleWrap.e5671a6694c7ecd88f2b5720fd93dad9.svg";
export { ForwardRef as ReactComponent };